module.exports = __webpack_public_path__ + "img/chat-cn.227a6572.svg";